import SplitNavLinks from './SplitNavLinks';

export default SplitNavLinks;
